import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { BackendService, NotificationService, ModalService } from 'beyond-util';

import { SifarnikBase } from '../sifarnici/sifarnik-base/sifarnik-base';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-pregled-ugovora-za-obracun',
  templateUrl: './pregled-ugovora-za-obracun.component.html',
})
export class PregledUgovoraZaObracunComponent extends SifarnikBase {
  public url: SafeResourceUrl;

  constructor(
    protected _backendService: BackendService,
    protected _notificationService: NotificationService,
    protected _modalService: ModalService,
    private _sanitizer: DomSanitizer
  ) {
    super(_backendService, _modalService, _notificationService);

    this.url = this.getSantizedURL();
  }

  getSantizedURL() {
    const token = sessionStorage.getItem('token');

    return this._sanitizer.bypassSecurityTrustResourceUrl(
      `${environment.pregledPodugovoraZaObracunUrl}?token=${token}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pregled-ugovora-za-obracun/pregled-ugovora-za-obracun.component.ts